"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
require("./singleCredential.scss");
const utils_1 = require("./utils");
const react_bootstrap_1 = require("react-bootstrap");
const react_bootstrap_2 = require("react-bootstrap");
const StorageDetails_1 = __importDefault(require("./components/storageDetails/StorageDetails"));
function SingleCredential(props) {
    return (react_1.default.createElement("div", { className: "single-credential" },
        react_1.default.createElement("img", { className: "credential-image", src: props.credential.logo, height: 170 }),
        react_1.default.createElement("div", { className: "flex-row ai-c" },
            react_1.default.createElement(react_bootstrap_2.OverlayTrigger, { placement: "top", overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { style: {
                        maxWidth: "400px",
                    } }, (0, utils_1.getStatusDescription)(props.credential, props.translate)) },
                react_1.default.createElement("img", { src: (0, utils_1.getStatusIcon)(props.credential), alt: (0, utils_1.getIssuerStatus)(props.credential), id: `custom-tooltip-${props.credential.title}`, height: 18, width: 18 })),
            react_1.default.createElement(react_bootstrap_2.OverlayTrigger, { placement: "top", overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { style: {
                        maxWidth: "400px",
                    } }, props.credential.subTitle) },
                react_1.default.createElement("span", { className: "credential-subtitle ellipsis" }, props.credential.subTitle))),
        react_1.default.createElement(react_bootstrap_2.OverlayTrigger, { placement: "top", overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { style: {
                    maxWidth: "400px",
                } }, props.credential.summaryDetail) },
            react_1.default.createElement("span", { className: "credential-summary-detail ellipsis two-line" }, props.credential.summaryDetail)),
        react_1.default.createElement("div", { className: "credential-card-footer flex-column" },
            react_1.default.createElement("div", { className: "credential-footer-issuer-info flex-row jc-sb" },
                react_1.default.createElement("span", { className: "credential-issuer-name" }, props.credential.issuer.name),
                react_1.default.createElement(StorageDetails_1.default, { credential: props.credential, translate: props.translate })),
            props.actionButtonsOptions && (react_1.default.createElement("div", { className: "action-button flex-row jc-fe", style: {
                    width: `${props.actionButtonsOptions.width}px`,
                } }, props.actionButtonsOptions.actionButton.customElement)))));
}
exports.default = SingleCredential;
